import React from 'react';

export const filterOptions = {
  urgencyLevels: ['Low', 'Medium', 'High', 'Highest'],
  states: ['MA', 'NY', 'CA', 'TX', 'FL'],
  modalities: [
    'CBT',
    'DBT',
    'ACT',
    'Psychodynamic',
    'EMDR',
    'Mindfulness',
    'Solution-Focused',
    'Narrative',
    'Gestalt',
    'Art Therapy',
    'Play Therapy'
  ],
  ageRanges: [
    'Children (0-12)',
    'Adolescents (13-17)',
    'Young Adults (18-25)',
    'Adults (26-64)',
    'Seniors (65+)'
  ],
  demographics: [
    'LGBTQ+',
    'BIPOC',
    'Veterans',
    'Students',
    'Professionals',
    'Parents',
    'Immigrants',
    'First Responders',
    'Healthcare Workers'
  ],
  specialties: [
    'Anxiety/Depression',
    'Trauma/PTSD',
    'Relationships',
    'Family Issues',
    'Substance Use Disorder',
    'Life Changes',
    'Grief',
    'Parenting Challenges',
    'Personality Disorders',
    'Neurodivergent Issues',
    'OCD',
    'Sexual Issues/Intimacy',
    'LGBTQ Issues',
    'Body Dysmorphia/Eating Disorders'
  ],
  sessionTypes: [
    { value: 'in-person', label: 'Individual Therapy' },
    { value: 'couples', label: 'Couples Therapy' },
    { value: 'family', label: 'Family Therapy' },
    { value: 'group', label: 'Group Therapy' }
  ],
  insuranceProviders: [
    'Blue Cross Blue Shield',
    'Aetna',
    'Cigna',
    'United Healthcare',
    'Medicare',
    'Medicaid',
    'Kaiser Permanente',
    'Optum',
    'Humana'
  ]
};

interface FilterTagProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

export const FilterTag: React.FC<FilterTagProps> = ({ label, selected, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`px-3 py-1 rounded-full text-sm font-medium ${
      selected
        ? 'bg-purple-100 text-purple-800'
        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
    }`}
  >
    {label}
  </button>
);

interface FilterSectionProps {
  title: string;
  options: string[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export const FilterSection: React.FC<FilterSectionProps> = ({
  title,
  options,
  selected,
  onChange,
}) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      {title}
    </label>
    <div className="flex flex-wrap gap-2">
      {options.map((option) => (
        <FilterTag
          key={option}
          label={option}
          selected={selected.includes(option)}
          onClick={() => {
            const newSelected = selected.includes(option)
              ? selected.filter((s) => s !== option)
              : [...selected, option];
            onChange(newSelected);
          }}
        />
      ))}
    </div>
  </div>
);